<template>
  <main class="self-color-select">
    <el-select
      v-model="ruleForm[keyName]"
      placeholder="请选择"
      popper-class="car-import-self-select"
    >
      <el-option
        class="car-import-self-options"
        v-for="item in colorOptions"
        :key="item.val"
        :label="item.label"
        :value="item.val"
      >
        <span
          v-if="item.label !== '其他'"
          class="color-circle"
          :style="{
            'background-color': bgColor[item.val],
            border: item.val === 'WHITE' ? '1px solid #DCDFE6' : 'none',
          }"
        ></span>
        <span v-if="item.label === '其他'" class="other-color"></span>
        <span class="label-weight">{{ item.label }}</span>
      </el-option>
    </el-select>
  </main>
</template>

<script>
import { colorOptions } from '../../constant/common-type.ts'
export default {
  data() {
    return {
      colorOptions: colorOptions,
      bgColor: {
        WHITE: 'WHITE',
        BLACK: 'BLACK',
        DARKGREY: 'DARKGREY',
        LIGHTGRAY: 'LIGHTGRAY',
        ORANGE: 'ORANGE',
        GREEN: 'GREEN',
        RED: 'RED',
        BLUE: 'BLUE',
        PURPLE: 'PURPLE',
        CHAMPAGNE: '#D1B9A5',
        YELLOW: 'YELLOW',
      },
    }
  },
  props: {
    ruleForm: {
      type: Object,
    },
    keyName: {
      type: String,
    },
  },
}
</script>

<style lang="stylus">
@import '../../assets/css/common-color.styl'
.car-import-self-select
  padding-bottom 10px
  .el-select-dropdown__list
    width 214px
    padding 10px
    .car-import-self-options
      display flex
      justify-content space-around
      align-items center
      width 50%
      float left
      border-radius 30px
      // width 80px
      .color-circle
        display inline-block
        width 14px
        height 14px
        border-radius 50%
      .other-color
        display inline-block
        width 14px
        height 14px
        background url('../../assets/images/car-manage/other-color.svg') no-repeat center center
      &:hover
        border-radius 30px
        color primary-color
      .label-weight
        width 30px
</style>
